import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';
import { PipelineTemplateSummary } from 'types/pipeline_template';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export type UsePipelineTemplatesParams = {
  category_labels?: string[];
  only_included_in_plan?: boolean;
  query?: string;
};

type UsePipelineTemplatesOptions = UseQueryOptions<
  OffsetPaginated<PipelineTemplateSummary>,
  APIError
> & {
  params?: UsePipelineTemplatesParams & OffsetPaginationParams;
};

export function usePipelineTemplates({
  queryKey = ['pipeline-templates'],
  params,
  ...options
}: UsePipelineTemplatesOptions = {}) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    only_included_in_plan: true,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get<
        OffsetPaginated<PipelineTemplateSummary>
      >(`/internal/apps/${applicationID}/pipeline_templates`, {
        params: queryParams,
      });

      return data;
    },
    options
  );
}
